import React, { useState } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
  Checkbox,
  FormGroup,
  FormControl,
  FormLabel
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const TabManager = ({ siteData, refetch }) => {
  const [processing, setProcessing] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  // Flatten all products from categories
const allProducts = siteData?.categories?.flatMap(cat =>
  (cat.products || []).map(prod => ({
    ...prod,
    categoryName: cat.name
  }))
) || [];
  // Tabs loaded from siteData.tabs
  const [tabs, setTabs] = useState(
    siteData?.tabs?.length
      ? siteData.tabs.map(tab => ({
          id: tab.id,
          name: tab.name,
          products: tab.products,
          active: tab.active !== false
        }))
      : [{
          name: '',
          products: [],
          active: true
        }]
  );

  const handleChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updated = [...tabs];

    if (type === 'checkbox' && name.startsWith('product_')) {
      const productId = parseInt(name.split('_')[1]);
      if (checked) {
        updated[index].products.push(productId);
      } else {
        updated[index].products = updated[index].products.filter(id => id !== productId);
      }
    } else if (type === 'checkbox') {
      updated[index][name] = checked;
    } else {
      updated[index][name] = value;
    }

    setTabs(updated);
  };

  const handleAddTab = () => {
   if(tabs.length<siteData.max_tabs){


    setTabs([
      ...tabs,
      {
        name: '',
        products: [],
        active: true
      }
    ]);}
    else{
            toast.error(`Max ${siteData.max_tabs} tabs are allowed`)

    }
  };

const handleSubmit = async (index) => {
  const tab = tabs[index];
  const formData = new FormData();
  setActiveIndex(index);

const requiredFields = [ 'name'];
  const missingFields = requiredFields.filter((field) => !tab[field]?.toString().trim());


  if (missingFields.length > 0) {
    toast.error(`Tab #${index + 1}: Please fill ${missingFields.join(', ')}`);
    return;
  }

 

  setProcessing(true);

  formData.append('name', tab.name);
    formData.append('site', siteData?.ID);

  formData.append('active', tab.active);
  if (tab.id) formData.append('id', tab.id);

tab.products.forEach(id => {
  formData.append('products', id);
});
  try {
    if (tab.id) {
      await api.put('tabs-v2', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(`Tab #${index + 1} updated`);
    } else {
      await api.post('tabs-v2', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(`Tab #${index + 1} created`);
    }

    refetch?.(); // Refresh data
  } catch (err) {
    console.error(err);
    toast.error(`Error ${tab.id ? 'updating' : 'creating'} tab #${index + 1}`);
  } finally {
    setProcessing(false);
  }
};

  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">Manage Tabs</Typography>

      {tabs.map((tab, index) => (
        <Paper key={index} style={{ padding: 16, marginBottom: 20, background: '#f9f9f9' }}>
          <Typography variant="subtitle1">Tab #{index + 1}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ textAlign: 'right' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={tab.active}
                    onChange={(e) => handleChange(index, e)}
                    name="active"
                    color="primary"
                  />
                }
                label="Active"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Tab Name"
                name="name"
                value={tab.name}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            <Grid container spacing={2}>
  {allProducts.map(product => (
    <Grid item style={{height:60}} xs={12} sm={6} md={4} key={product.id}>
      <FormControlLabel
      
        control={
          <Checkbox
          style={{paddingBottom:35}}
            checked={tab.products.find(val=>val===product.id)}
            onChange={(e) => handleChange(index, e)}
            name={`product_${product.id}`}
            color="primary"
          />
        }
        label={
          <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
            {product.name} <span style={{ color: '#888' }}>({product.categoryName})</span>
          </span>
        }
        style={{ alignItems: 'center' }}
      />
    </Grid>
  ))}
</Grid>


            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSubmit(index)}
                disabled={processing}
              >
                {processing && index === activeIndex
                  ? 'Processing...'
                  : tab.id
                  ? `Update Tab #${index + 1}`
                  : `Submit Tab #${index + 1}`}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ))}

      <Button
        variant="contained"
        color="primary"
        onClick={handleAddTab}
      >
        + Add Tab
      </Button>
    </Paper>
  );
};

export default TabManager;
